module.exports = __webpack_public_path__ + "8ae5cb544b933c39787c623f5b5735a2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_1_0.ttf
// module id = 2247
// module chunks = 2